import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

/**
 * Http Timeout Interceptor.
 */
@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
  private readonly TIMEOUT = 30 * 1000; // 30 seconds

  /**
   * Intercept request.
   *
   * @template T - The type of the request.
   * @param {HttpRequest<T>} req Request.
   * @param {HttpHandler} next The next interceptor in the chain.
   * @returns {Observable<HttpEvent<T>>}
   */
  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    const duration = req.timeout ?? this.TIMEOUT;
    return next.handle(req).pipe(timeout(duration));
  }
}
